import { useIntl } from "react-intl";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from "Components/Notifications";
import TableAlertTypes from 'Modules/manufacturers/.components/deviceModelsTab/.components/createEditDeviceModel/.components/editAlertTypeSupported/.components/table'

//Styles
import './index.scss'

//Actions
import {
    searchEntityRequest,
    editAlertTypeSupportedUpdateAlertTypesRequest,
    clearRedux,
} from 'Redux/actions';

const EditAlertTypeSupported = (props) => {
    const { setChanges, subGroup } = props
    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Local States
    const [selected, setSelected] = useState([]);
    const [currentSearch, setCurrentSearch] = useState("");
    const [parents, setParents] = useState([]);

    const { openModal, loading, result, deviceModel, alertTypes: alertTypesSupported } = useSelector(state => state.editAlertTypeSupportedRedux);
    const alertTypes = useSelector(state => state.generalRedux.alertTypes);

    const closeModal = () => {
        dispatch(clearRedux("EDIT_ALERT_TYPE_SUPPORTED"))
    }

    useEffect(() => {
        if (result && !result?.error) {
            NotificationManager.success(
                messages['edit_alert_type_supported_success_message'],
                messages['edit_alert_type_supported_title'],
                3000,
            );
            dispatch(clearRedux("EDIT_ALERT_TYPE_SUPPORTED"))
        } else if (result?.error) {
            NotificationManager.error(
                messages['edit_alert_type_supported_error_message'],
                messages['edit_alert_type_supported_title'],
                3000,
            );
            dispatch(clearRedux("EDIT_ALERT_TYPE_SUPPORTED", { result: null }))
        }
    }, [result])

    useEffect(() => {
        dispatch(searchEntityRequest({ key: "alertTypes" }));
    }, []);

    const applyChanges = () => {
        let payload = {
            id: `${deviceModel?.id}`,
            alertTypeIds: selected
        }
        dispatch(editAlertTypeSupportedUpdateAlertTypesRequest(payload))
    }

    useEffect(() => {
        if (alertTypesSupported && alertTypesSupported?.length) {
            let ids = alertTypesSupported.map((item) => item.alertTypeId)
            setSelected(ids)
            let template = alertTypes.filter((item) => item?.parentId).map((item) => (item?.parentId))
            template = template?.length ? template.filter((value, index) => template?.indexOf(value) === index) : []
            setParents(template)
        }
    }, [alertTypesSupported])

    return (
        <Modal
            open={openModal}
            title={`${messages['edit_alert_type_supported_title']} (${deviceModel?.name || ''})`}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody className="edit-alert-type">
                <div style={{ padding: '0 10px' }}>
                    <TableAlertTypes
                        setCurrentSearch={setCurrentSearch}
                        alertTypes={alertTypes}
                        subGroup={subGroup}
                        setSelected={setSelected}
                        currentSearch={currentSearch}
                        setChanges={setChanges}
                        selected={selected}
                        parents={parents}
                    />
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => applyChanges()}
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default EditAlertTypeSupported;